"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ConfirmModalContent = _interopRequireDefault(require("./ConfirmModalContent"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

var _ModalWrap = _interopRequireDefault(require("./ModalWrap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * The ConfirmModal is used for prompt dialogue interactions that require the user's full attention.
 * @keywords ConfirmPopup, ConfirmDialog
 */
var ConfirmModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ConfirmModal, _React$Component);

  function ConfirmModal() {
    _classCallCheck(this, ConfirmModal);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConfirmModal).apply(this, arguments));
  }

  _createClass(ConfirmModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cancelButtonLabel = _this$props.cancelButtonLabel,
          cancelButtonProps = _this$props.cancelButtonProps,
          children = _this$props.children,
          confirmButtonLabel = _this$props.confirmButtonLabel,
          confirmButtonProps = _this$props.confirmButtonProps,
          header = _this$props.header,
          footer = _this$props.footer,
          onCancel = _this$props.onCancel,
          onConfirm = _this$props.onConfirm,
          visible = _this$props.visible,
          width = _this$props.width,
          props = _objectWithoutProperties(_this$props, ["cancelButtonLabel", "cancelButtonProps", "children", "confirmButtonLabel", "confirmButtonProps", "header", "footer", "onCancel", "onConfirm", "visible", "width"]);

      return _react.default.createElement(_ModalWrap.default, _extends({
        "data-type": "confirm",
        visible: visible
      }, props), _react.default.createElement(_ConfirmModalContent.default, {
        cancelButtonLabel: cancelButtonLabel,
        cancelButtonProps: cancelButtonProps,
        confirmButtonLabel: confirmButtonLabel,
        confirmButtonProps: confirmButtonProps,
        header: header,
        footer: footer,
        onCancel: onCancel,
        onConfirm: onConfirm,
        visible: visible,
        width: width
      }, children));
    }
  }]);

  return ConfirmModal;
}(_react.default.Component);

exports.default = ConfirmModal;
ConfirmModal.ConfirmModalContent = _ConfirmModalContent.default;
ConfirmModal.defaultProps = {
  cancelButtonLabel: _I18nManager.default.t('ConfirmModal', 'cancel'),
  confirmButtonLabel: _I18nManager.default.t('ConfirmModal', 'confirm'),
  footer: true,
  width: 400
};
ConfirmModal.propTypes = {
  /**
   * cancelButtonLabel is the label for the secondary action button on the
   * modal footer.
   */
  cancelButtonLabel: _propTypes.default.string,

  /**
   * Props to be passed to cancel button
   */
  cancelButtonProps: _propTypes.default.object,

  /**
   * Body content goes here.
   */
  children: _propTypes.default.node,

  /**
   * Customize additional class name for the modal.
   */
  className: _propTypes.default.string,

  /**
   * confirmButtonLabel is the label for the primary action button on the
   * modal footer.
   */
  confirmButtonLabel: _propTypes.default.string,

  /**
   * Props to be passed to confirm button
   */
  confirmButtonProps: _propTypes.default.object,

  /**
   * The header title for the confirm modal.
   */
  header: _propTypes.default.node,

  /**
   * Footer for confirm modal. Can be a node or default as true. Use {false} to remove. When set
   * to a value other than true, the props onConfirm, onCancel, confirmButtonLabel, and
   * cancelButtonLabel will no longer be usable.
   */
  footer: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node]),

  /**
   * onCancel is used to handle when cancel button is clicked.
   */
  onCancel: _propTypes.default.func,

  /**
   * onConfirm is the action for the primary action button on the
   * modal footer.
   */
  onConfirm: _propTypes.default.func,

  /**
   * Visible is to determine whether a modal dialog is visible or not.
   */
  visible: _propTypes.default.bool,

  /**
   * Width of a modal dialog (in px)
   */
  width: _propTypes.default.number
};